module.exports = __webpack_public_path__ + "static/img/bl.8028dd11.svg";